"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    toastClassNames: function() {
        return toastClassNames;
    },
    useToastStyles_unstable: function() {
        return useToastStyles_unstable;
    }
});
const _react = require("@griffel/react");
const toastClassNames = {
    root: 'fui-Toast'
};
const useRootBaseClassName = /*#__PURE__*/ (0, _react.__resetStyles)("rhf7k35", null, [
    ".rhf7k35{display:grid;grid-template-columns:auto 1fr auto;padding:12px;border-radius:var(--borderRadiusMedium);border:1px solid var(--colorTransparentStroke);box-shadow:var(--shadow8);font-size:var(--fontSizeBase300);line-height:20px;font-weight:var(--fontWeightSemibold);color:var(--colorNeutralForeground1);background-color:var(--colorNeutralBackground1);}"
]);
const useStyles = /*#__PURE__*/ (0, _react.__styles)({
    inverted: {
        sj55zd: "f1w7i9ko",
        De3pzq: "f5pduvr"
    }
}, {
    d: [
        ".f1w7i9ko{color:var(--colorNeutralForegroundInverted2);}",
        ".f5pduvr{background-color:var(--colorNeutralBackgroundInverted);}"
    ]
});
const useToastStyles_unstable = (state)=>{
    'use no memo';
    const rootBaseClassName = useRootBaseClassName();
    const styles = useStyles();
    state.root.className = (0, _react.mergeClasses)(toastClassNames.root, rootBaseClassName, state.backgroundAppearance === 'inverted' && styles.inverted, state.root.className);
    return state;
}; //# sourceMappingURL=useToastStyles.styles.js.map
